import {React, _, observer, classNames, InfiniteScroll, useEffect, pluralize, useIntersectionObserver} from '@api'
import {Spinner} from '@blueprintjs/core'
import {trace} from 'mobx'
import {useGroupByRootStore, GroupByGroup, StackedGroups} from './'

import {Fragment, useMemo} from 'react'
import * as css from './RootGroupsChildrenGroups.css'

/*export const RootGroupsChildrenGroups: React.FunctionComponent = () =>
  useObserver(() => {
    const store = useGroupByRootStore(),
      {mgr: {partitionedGroups, remainingToLoad, onClickLoadMore}, grouping: {isLeaf}} = store

    // const flipId = groupName
    // useFlipGroup({
    //                flipId,
    //                opts: {duration: 800},
    //                deps: data
    //              })
    return <div
      className={css.root}
      //data-grid={stackView && hierarchy.length == 2 ? true : null}
      data-leaf={isLeaf}
    >
      {partitionedGroups.
        filter(rowData => (!_.isArray(rowData) && rowData.count) || (_.isArray(rowData) && rowData.length))
        .map((rowData, i) => <GroupByRow_LoadMore rowData={rowData} key={i} index={i}/>)}
      {remainingToLoad > 0 && <Button minimal
                                      className={css.loadMoreButton} onClick={onClickLoadMore} text={`Load More (${remainingToLoad} left)`}/>}
    </div>
  })*/

export const GroupByCatalogRoot_ChildrenGroupsInfinite = observer(function GroupByCatalogRoot_ChildrenGroupsInfinite() {
  const store = useGroupByRootStore(),
    {mgr: {visibleGroups, hasMore}, grouping: {isLeaf, allowCardMode}, groupBy: {settings: {groupView, columnView}}} = store

  return (
    <div
      className={classNames(css.root, css.infinite)}
      //getScrollParent={() => document.getElementById(GROUPS_SCROLL_ID)}
      data-leaf={isLeaf}
      data-view={allowCardMode ? groupView : 'flat'}
      data-column-view={columnView}
      data-has-more={hasMore}
    >
      {visibleGroups.map((rowData, i) => <GroupByRow_LoadMore rowData={rowData} key={i} index={i}/>)}
      {/*{remainingToLoad > 0 && <Button className={css.loadMoreButton} onClick={onClickLoadMore} text={`Load More (${remainingToLoad} left)`}/>}*/}
      {hasMore && <LoadMoreGroupsLoader key='loader'/>}
      {columnView && <div className={css.gridCellFiller}/>}
    </div>
  )
})

GroupByCatalogRoot_ChildrenGroupsInfinite.displayName = 'GroupByCatalogRoot_ChildrenGroupsInfinite'
GroupByCatalogRoot_ChildrenGroupsInfinite['whyDidYouRender'] = true

export const LoadMoreGroupsLoader = observer(function LoadMoreGroupsLoader() {
  const {strings, mgr: {timesClicked, hasMore, onClickLoadMore_infinite, loading, groupCount, data, grouping: { itemCount, hierarchyTypeGroup}}} = useGroupByRootStore(),
    remaining = (hierarchyTypeGroup ? itemCount : groupCount) - data.length

  const [entry, observerRef] = useIntersectionObserver()

  useEffect(() => {
    if (entry.isIntersecting && hasMore && !loading) {
      onClickLoadMore_infinite(timesClicked + 1)
    }
  }, [entry.isIntersecting, hasMore, loading])

  return <div
    className={css.loadMoreGroupsIndicator}
    data-loading={loading}
    ref={observerRef}
    onClick={e => {
      if (hasMore && !loading) {
        onClickLoadMore_infinite(timesClicked + 1)
      }
    }}
  >
    <span className={css.loadMoreText}>{loading ? strings.loadingMoreGroups : strings.loadMoreGroups}<br/>({remaining} Left)</span>
    {loading && <Spinner size={18}/>}
  </div>
})

/**
 * This can be a single expanded or collapsed row when in flat mode (or VLP), or can be a row with a bunch of groups in it when in Concept Board
 */
export const GroupByRow_LoadMore = observer<{ index, rowData }>(function GroupByRow_LoadMore(props) {
  const {index, rowData} = props ?? {},
    store = useGroupByRootStore(),
    {mgr: {groupName, groupCount, grouping}} = store

  const data = rowData,
    singleGroup = data && !_.isArray(data),
    childProps = useMemo(() => ({index, groupName, groupCount}), [index, groupName, groupCount])

  if (!data) return <div data-error={`No data for row index ${index}`}/>

  // console.log({data, singleGroup, index})

  return (
    <Fragment>
      {singleGroup ? <GroupByGroup key={data.key} group={data.key} info={data} hideChildren={false} inGridCell={grouping.isFlat} {...childProps}/>
                : data.map((info, j) => info && <GroupByGroup key={j} group={info.key} info={info} hideChildren={true} {...childProps}/>)}
    </Fragment>
  )
})

GroupByRow_LoadMore['whyDidYouRender'] = true
GroupByRow_LoadMore.displayName = 'GroupByRow_LoadMore'


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/RootGroupsChildrenGroups.tsx